import { apiClient } from '../../api/client';
import type { components } from '../../api/generated/schema';
import type { NewReport } from '../../domain/safety';
import { toConversationSummary } from '../conversations/mapping';
import { mapped } from '../errors';
import type { SafetyRepository } from './SafetyRepository';
import { toBlock, toNewReport, toReportReceipt } from './mapping';

type S = components['schemas'];

export const httpSafetyRepository: SafetyRepository = {
  blocks: () =>
    mapped(async () => (await apiClient.get<S['Block'][]>('/api/v1/blocks/')).map(toBlock)),
  block: (personId: string, leaveConversationIds: string[]) =>
    mapped(async () =>
      toBlock(
        await apiClient.send<S['Block']>('POST', '/api/v1/blocks/', {
          person_id: personId,
          leave_conversation_ids: leaveConversationIds,
        }),
      ),
    ),
  endBlock: (blockId: string) =>
    mapped(async () => {
      await apiClient.send('DELETE', `/api/v1/blocks/${encodeURIComponent(blockId)}/`);
    }),
  blockPreview: (personId: string) =>
    mapped(async () => ({
      sharedGroupConversations: (
        await apiClient.get<S['ConversationSummary'][]>(
          `/api/v1/people/${encodeURIComponent(personId)}/block-preview/`,
        )
      ).map(toConversationSummary),
    })),
  report: (report: NewReport) =>
    mapped(async () =>
      toReportReceipt(
        await apiClient.send<S['ReportReceipt']>('POST', '/api/v1/reports/', toNewReport(report)),
      ),
    ),
};
